import { render, staticRenderFns } from "./BatteryList.vue?vue&type=template&id=5406a25c&"
import script from "./BatteryList.vue?vue&type=script&lang=js&"
export * from "./BatteryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports